<div class="dashboard-container" [ngClass]="{ pointerEventesHide: showFilter }">
  <div *ngIf="!isEditPage">
    <div class="d-flex justify-content-between align-items-center mb-4 gap-2">
      <div>
        <div class="header-text">Hello, {{ user.name }}!</div>
        <div class="second-header-text">
          Welcome back to the Construction Pathways dashboard
        </div>
      </div>

      <div
        class="status-dropdown-container"
        *ngIf="
          userRoles?.addTeacher ||
          userRoles?.addStudent ||
          userRoles?.addSchool ||
          userRoles?.addEvent ||
          userRoles?.addCSQAdmin
        "
      >
        <div class="status-display" (click)="toggleStatusDropdown($event)">
          <img src="assets/images/add-icon.svg" alt="plus" class="plus-icon" />
          {{ "Add" }}
          <img
            src="assets/images/Buttons/arrow.svg"
            class="dropdown-arrow"
            [class.rotated]="!showStatusDropdown"
          />
        </div>

        <div
          class="status-dropdown-menu"
          [class.show]="showStatusDropdown"
          (click)="$event.stopPropagation()"
        >
          <button
            class="status-option"
            *ngIf="userRoles?.addTeacher"
            (click)="openAddTeacherDialog()"
            [class.disabled]="isProcessing"
          >
            <span>Add teacher</span>
          </button>

          <button
            class="status-option"
            *ngIf="userRoles?.addStudent"
            (click)="openAddStudentDialog()"
            [class.disabled]="isProcessing"
          >
            <span>Add student</span>
          </button>

          <button
            class="status-option"
            *ngIf="userRoles?.addSchool"
            (click)="openAddSchoolDialog()"
            [class.disabled]="isProcessing"
          >
            <span>Add school</span>
          </button>

          <button
            class="status-option"
            *ngIf="userRoles?.addEvent"
            (click)="onCreateEvent()"
            [class.disabled]="isProcessing"
          >
            <span>Add event</span>
          </button>
          <button
            class="status-option"
            *ngIf="userRoles?.addCSQAdmin"
            (click)="openAddCSQUserDialog('admin')"
            [class.disabled]="isProcessing"
          >
            <span>Add CSQ admin</span>
          </button>
        </div>

        <div
          class="status-backdrop"
          *ngIf="showStatusDropdown"
          (click)="closeStatusDropdown()"
        ></div>
      </div>
    </div>

    <!-- Card Section -->
    <div style="display: grid; grid-template-columns: 12fr; gap: 1rem">
      <div class="view-card-colab">
        <div class="d-grid gap-3">
          <div class="new_anal">All time portal analytics</div>
          <div class="card-section" [ngStyle]="{ opacity: loading ? 0.5 : 1 }">
            <div
              (click)="roleValue !== 'csquser' && navigateToRoute('users')"
              class="card bg-blue card-bg-pattern"
              [style.cursor]="roleValue !== 'csquser' ? 'pointer' : 'initial'"
            >
              <div class="card-content">
                <div>
                  <div class="card-title">Total users</div>
                  <div class="d-flex align-items-center gap-3">
                    <img
                      src="assets/icons/dashboard/users.svg"
                      alt="Users"
                      class="icon-round"
                    />
                    <div class="card-value">{{ cardCount?.totalUsers }}</div>
                  </div>
                </div>
                <div *ngIf="roleValue != 'csquser'">
                  <img
                    src="assets/images/card-go.svg"
                    alt="Users"
                    class="icon-round"
                  />
                </div>
              </div>
            </div>

            <div
              (click)="navigateToRoute('events')"
              class="card bg-orange card-bg-pattern2"
            >
              <div class="card-content">
                <div>
                  <div class="card-title">Total events</div>
                  <div class="d-flex align-items-center gap-3">
                    <img
                      src="assets/icons/dashboard/events.svg"
                      alt="events"
                      class="icon-round"
                    />
                    <div class="card-value">{{ cardCount?.totalEvents }}</div>
                  </div>
                </div>
                <div>
                  <img
                    src="assets/images/card-go.svg"
                    alt="Users"
                    class="icon-round"
                  />
                </div>
              </div>
            </div>

            <div
              (click)="navigateToRoute('')"
              class="card bg-green card-bg-pattern"
            >
              <div class="card-content">
                <div>
                  <div class="card-title">Completed events</div>
                  <div class="d-flex align-items-center gap-3">
                    <img
                      src="assets/icons/dashboard/c-events.svg"
                      alt="Users"
                      class="icon-round"
                    />
                    <div class="card-value">
                      {{ cardCount?.completedEvents }}
                    </div>
                  </div>
                </div>
                <!-- <div>
                                    <img src="assets/images/card-go.svg" alt="Users" class="icon-round" />
                                </div> -->
              </div>
            </div>

            <div
              (click)="navigateToRoute('schools')"
              class="card bg-yellow card-bg-pattern2"
            >
              <div class="card-content">
                <div>
                  <div class="card-title">Total schools</div>
                  <div class="d-flex align-items-center gap-3">
                    <img
                      src="assets/icons/dashboard/school.svg"
                      alt="school"
                      class="icon-round"
                    />
                    <div class="card-value">{{ cardCount?.totalSchools }}</div>
                  </div>
                </div>
                <div>
                  <img
                    src="assets/images/card-go.svg"
                    alt="school"
                    class="icon-round"
                  />
                </div>
              </div>
            </div>

            <div
              (click)="navigateToRoute('student')"
              class="card bg-purple card-bg-pattern"
            >
              <div class="card-content">
                <div>
                  <div class="card-title">Total students</div>
                  <div class="d-flex align-items-center gap-3">
                    <img
                      src="assets/icons/dashboard/attendance.svg"
                      alt="attendance"
                      class="icon-round"
                    />
                    <div class="card-value">{{ cardCount?.totalStudents }}</div>
                  </div>
                </div>
                <div>
                  <img
                    src="assets/images/card-go.svg"
                    alt="attendance"
                    class="icon-round"
                  />
                </div>
              </div>
            </div>

            <div
              (click)="navigateToRoute('partner')"
              class="card bg-red card-bg-pattern2"
            >
              <div class="card-content">
                <div>
                  <div class="card-title">Industry partners</div>
                  <div class="d-flex align-items-center gap-3">
                    <img
                      src="assets/icons/dashboard/partners.svg"
                      alt="partners"
                      class="icon-round"
                    />
                    <div class="card-value">
                      {{ cardCount?.totalIndustryPartners }}
                    </div>
                  </div>
                </div>
                <div>
                  <img
                    src="assets/images/card-go.svg"
                    alt="partners"
                    class="icon-round"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="chart-card chart-large">
            <div class="event-analysis-filter-section">
              <div class="chart-header">Event analysis</div>
              <form
                class="dashboard-filter-form"
                [formGroup]="eventAnalysisFilterForm"
                (ngSubmit)="applyEventAnalysisFilters()"
              >
                <div class="dashboard-filter-row res-wrp">
                  <div class="form-group dashboard-filter-control">
                    <app-input
                      context="Normal"
                      placeholder="From"
                      label="Start date"
                      type="date"
                      formControlName="startDate"
                      [control]="eventAnalysisFilterForm.get('startDate')"
                      (dateChange)="onStartDateChange($event)"
                      [max]="null"
                      [disableWeekends]="true"
                      [labelGap]="true"
                      [customErrorMessages]="{
                        required: 'Please enter a start date',
                      }"
                    >
                    </app-input>
                  </div>

                  <div class="form-group dashboard-filter-control">
                    <app-input
                      context="Normal"
                      placeholder="To"
                      type="date"
                      label="End date"
                      formControlName="endDate"
                      [control]="eventAnalysisFilterForm.get('endDate')"
                      (dateChange)="onEndDateChange($event)"
                      [labelGap]="true"
                      [min]="getMinEndDate()"
                      [disableWeekends]="true"
                      [customErrorMessages]="{
                        required: 'Please enter an end date',
                        dateRange: 'End date must be after start date',
                      }"
                    >
                    </app-input>
                  </div>

                  <div class="dashboard-multi-select">
                    <app-multi-select
                      [label]="'Event type'"
                      placeholder="Select event types"
                      [options]="eventTypes"
                      formControlName="eventTypes"
                      [required]="false"
                      [searchable]="true"
                      [showCheckBox]="true"
                    >
                    </app-multi-select>
                  </div>

                  <div class="dashboard-multi-select">
                    <app-multi-select
                      [label]="'Region'"
                      placeholder="Select regions"
                      [options]="regions"
                      formControlName="regions"
                      [required]="false"
                      [searchable]="true"
                      [showCheckBox]="true"
                    >
                    </app-multi-select>
                  </div>

                  <div class="dashboard-filter-actions">
                    <button
                      type="submit"
                      class="dashboard-filter-apply"
                      [disabled]="eventAnalysisFilterForm.invalid"
                    >
                      Apply Filters
                    </button>

                    <button
                      type="button"
                      class="dashboard-filter-reset"
                      (click)="resetEventAnalysisFilters()"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="chart-second-text">Event count by type</div>
            <div
              style="
                height: 300px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              "
              *ngIf="eventAnalysisLoading"
            >
              <div class="spinner"></div>
            </div>
            <div *ngIf="!eventAnalysisLoading" style="overflow-x: auto; width: 100%;">
              <app-universal-chart
                [options]="analysisByYear"
              ></app-universal-chart>
            </div>
          </div>
        </div>

        <div
          class="quick-actions-card"
          style="
            display: flex;
            justify-content: space-between;
            flex-direction: column;
          "
        >
          <div>
            <div class="d-flex flex-column gap-4 p-3">
              <div class="button-group">
                <button
                  class="quick_button"
                  [disabled]="selectedWeek === 'previous'"
                  [ngClass]="{ active: selectedWeek === 'previous' }"
                  (click)="onWeekselection('previous')"
                >
                  Previous week
                </button>
                <button
                  class="quick_button"
                  [disabled]="selectedWeek === 'current'"
                  (click)="onWeekselection('current')"
                  [ngClass]="{ active: selectedWeek === 'current' }"
                >
                  This week
                </button>
                <button
                  class="quick_button"
                  [disabled]="selectedWeek === 'next'"
                  (click)="onWeekselection('next')"
                  [ngClass]="{ active: selectedWeek === 'next' }"
                >
                  Next week
                </button>
              </div>
              <button class="quick_button current-week" *ngIf="currentWeek">
                {{ currentWeek }}
              </button>
            </div>

            <div class="quick-actions-header">
              {{
                selectedWeek === "previous"
                  ? "Completed events"
                  : "Upcoming events"
              }}
            </div>

            <div>
              <div
                class="upcoming-container"
                style="
                  height: 80%;
                  display: flex;
                  justify-content: space-between;
                  flex-direction: column;
                "
              >
                <div *ngIf="dashboardEventData.length === 0 && !eventLoading">
                  <p class="no-data">No data available</p>
                </div>

                <span *ngIf="eventLoading" class="loading-text"
                  >Loading data...</span
                >

                <ng-container>
                  <div
                    *ngFor="let item of dashboardEventData | slice: 0 : 10"
                    [title]="item.eventName"
                    class="d-flex gap-2 align-items-center uEvent-card"
                    (click)="navigateToEvents(item)"
                  >
                    <img
                      class="up-prf-img"
                      [src]="item.imageUrl"
                      [alt]="item.eventName"
                      (error)="
                        item.imageUrl = 'assets/images/placeholder-image.svg'
                      "
                    />
                    <div class="d-grid">
                      <span class="up-prf-name">{{ item.eventName }}</span>
                      <span class="up-prf-role">{{
                        item.eventHostRegionName
                      }}</span>
                    </div>
                    <div class="d-grid ms-auto text-end">
                      <span class="up-prf-role"
                        >{{ item.eventStartDate | date: "EEE dd" }}
                      </span>
                      <span class="up-prf-role">{{ item?.eventTime }}</span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <button
            class="view-all"
            *ngIf="
              dashboardEventData.length > 0 && dashboardEventData.length > 10
            "
            (click)="navigateToEventsPage()"
          >
            View all
          </button>
        </div>

        <!-- <div class="chart-small">
                <app-custom-calendar [selectedDate]="selectedDate" [eventDates]="eventDates"
                (dateChange)="onCustomDateChange($event)" (eventDateClick)="onEventDateClick($event)">
            </app-custom-calendar>
        </div> -->
      </div>

      <div class="view-card-colab">
        <div class="chart-card chart-large">
          <div class="chart-header">School engagement list</div>

          <!-- <div style="height:300px;width: 100%;display: flex;align-items: center;justify-content: center;"
                        *ngIf="loadingReports">
                        <div class="spinner"></div>
                    </div>
                    <div *ngIf="!loadingReports">
                        <app-universal-chart [options]="focusAreaChart"></app-universal-chart>
                    </div> -->
          <div class="mt-3">
            <app-table
              [columns]="schlEngagementColumns"
              [data]="schoolEngagementListData"
              [loading]="loading"
            ></app-table>
          </div>
        </div>

        <div class="event-show-card">
          <div class="chart-header" style="margin-bottom: 1rem">
            Top 5 engaged schools
          </div>
          <div
            style="
              height: 300px;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            *ngIf="loadingRegionReports"
          >
            <div class="spinner"></div>
          </div>
          <div *ngIf="!loadingRegionReports" class="completed-events">
            <!-- <app-radial-chart [options]="completedEventsYearly"></app-radial-chart> -->

            <app-universal-chart
              [options]="analysisByYear2"
            ></app-universal-chart>
          </div>
        </div>
      </div>

      <div class="table-section d-none">
        <div class="segment-row">
          <div class="segment-buttons">
            <button
              [class.active]="selectedSegment === 'upcoming'"
              (click)="switchSegment('upcoming')"
            >
              Upcoming Events
            </button>
            <button
              [class.active]="selectedSegment === 'recent'"
              (click)="switchSegment('recent')"
            >
              Recent Details
            </button>
          </div>
          <div class="d-flex align-items-center gap-4">
            <div class="table-date-range">
              <img src="assets/images/calendar.svg" alt="calendar" />
              01 Dec 2024 - 31 Dec 2024
              <mat-icon class="ml-1">keyboard_arrow_down</mat-icon>
            </div>
            <!-- <button class="filter-button" (click)="openFilterModal()">
                    <img src="assets/images/filter-edit.svg" alt="search" class="search-icon" />
                </button> -->
          </div>

          <div *ngIf="showFilter" class="filter-menu pointerEvents">
            <div class="filter-header">
              <h3>Filter by</h3>
              <button class="close-btn" (click)="closeFilterModal()">
                <img src="assets/images/cross-icon.svg" class="cross-icon" />
              </button>
            </div>
            <div class="filter-content">
              <div class="filter-group">
                <label>Date range</label>
                <div class="date-range">
                  <app-input
                    context="Normal"
                    class="form-item"
                    label="From"
                    placeholder="Enter From"
                    type="date"
                    formControlName="eventDate"
                    [control]=""
                    today="today"
                    [customErrorMessages]="customErrorMessages.eventDate"
                  >
                  </app-input>

                  <app-input
                    context="Normal"
                    class="form-item"
                    label="To"
                    placeholder="Enter To"
                    type="date"
                    formControlName="eventDate"
                    [control]=""
                    today="today"
                    [customErrorMessages]="customErrorMessages.eventDate"
                  >
                  </app-input>
                </div>
              </div>
              <div class="filter-group">
                <app-input
                  context="Normal"
                  class="form-item"
                  label="Event type"
                  placeholder="Event type"
                  type="select"
                  [control]="studentForm.get('eventType')"
                  [options]="eventOptions"
                  [customErrorMessages]="customErrorMessages.eventType"
                >
                </app-input>
              </div>
              <div class="filter-group">
                <app-input
                  context="Normal"
                  class="form-item"
                  label="Event managers"
                  placeholder="Event manager"
                  type="select"
                  [control]="studentForm.get('eventManager')"
                  [options]="eventManagers"
                  [customErrorMessages]="customErrorMessages.eventManager"
                >
                </app-input>
              </div>
              <div class="filter-group">
                <app-input
                  context="Normal"
                  class="form-item"
                  label="Event region"
                  placeholder="Event region"
                  type="select"
                  [control]="studentForm.get('schoolName')"
                  [options]="regionOptions"
                  [customErrorMessages]="customErrorMessages.schoolName"
                >
                </app-input>
              </div>
              <div class="filter-actions">
                <button class="clear-btn" (click)="onClearFilters()">
                  Clear all
                </button>
                <button class="apply-btn" (click)="onApplyFilters()">
                  Apply filters
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4 px-3">
          <app-table
            [columns]="columns"
            [data]="data"
            [loading]="loading"
            [status]="showstatus"
            *ngIf="selectedSegment === 'upcoming'"
            (rowClick)="onView($event)"
          ></app-table>

          <app-table
            [columns]="reColumns"
            [data]="reData"
            [loading]="loading"
            [status]="showstatus"
            *ngIf="selectedSegment === 'recent'"
            (rowClick)="onRecentView($event)"
          ></app-table>
        </div>
      </div>
    </div>
  </div>

  <div class="header-text" *ngIf="isEditPage">Edit Profile</div>
  <div class="edit-page" *ngIf="isEditPage">
    <div class="edit-bg">
      <app-profile></app-profile>
    </div>
    <div class="edit-bg">
      <app-password></app-password>
    </div>
  </div>

  <ng-template #statusButton let-row>
    <div [ngClass]="row?.status === 'Active' ? 'approved-text' : 'denied-text'">
      {{ row?.status === "Active" ? "Approved" : "Denied" }}
    </div>
  </ng-template>

  <ng-template #addEventTypeContent>
    <add-event-type
      [initialData]="editingEventType"
      (formSubmitted)="onEventTypeFormSubmit($event)"
    >
    </add-event-type>
  </ng-template>

  <ng-template #addEventManager>
    <add-event-manager
      [initialData]="editingEventType"
      (formSubmitted)="onEventManagerFormSubmit($event)"
    >
    </add-event-manager>
  </ng-template>

  <ng-template #addEventAudienceType>
    <add-audience
      [initialData]="editingEventType"
      (formSubmitted)="onAudienceTypeFormSubmit($event)"
    >
    </add-audience>
  </ng-template>

  <ng-template #addEventFocusArea>
    <add-focus-area
      [initialData]="editingEventType"
      (formSubmitted)="onFocusAreaFormSubmit($event)"
    >
    </add-focus-area>
  </ng-template>

  <ng-template #addEventRegion>
    <add-region
      [initialData]="editingEventType"
      (formSubmitted)="onRegionFormSubmit($event)"
    >
    </add-region>
  </ng-template>

  <ng-template #addCSQContent>
    <div class="dialog-content">
      <form [formGroup]="csqForm" class="d-grid gap-14">
        <div class="d-flex gap-2">
          <div class="form-group w-100">
            <app-input
              context="Normal"
              class="form-item"
              label="First name"
              placeholder="Enter your first name"
              type="text"
              [control]="csqForm.get('firstName')"
              formControlName="firstName"
              [control]="csqForm.get('firstName')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.firstName"
            >
            </app-input>
          </div>

          <div class="form-group w-100">
            <app-input
              context="Normal"
              class="form-item"
              label="Last name"
              placeholder="Enter your last name"
              type="text"
              [control]="csqForm.get('lastName')"
              formControlName="lastName"
              [control]="csqForm.get('lastName')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.lastName"
            >
            </app-input>
          </div>
        </div>

        <div class="d-flex gap-2">
          <div class="form-group w-100">
            <app-input
              context="Normal"
              class="form-item"
              label="Email"
              placeholder="Enter your email"
              type="email"
              formControlName="email"
              [control]="csqForm.get('email')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.email"
            >
            </app-input>
          </div>

          <div class="form-group w-100">
            <app-input
              context="Normal"
              class="form-item"
              label="Phone number"
              placeholder="Enter your phone number"
              type="text"
              formControlName="mobileNumber"
              [control]="csqForm.get('mobileNumber')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.mobileNumber"
            >
            </app-input>
          </div>
        </div>
      </form>
    </div>
  </ng-template>
</div>
